<template>
  <div>
    <v-text-field
      v-model="formData.kc"
      label="KC"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchKC"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div v-for="item in data" :key="item.id" class="mb-5 page-break">
        <div class="header">
          <div class="left">
            <h2 class="report-title">TANDA TERIMA PENYERAHAN BARANG</h2>
            <h3 class="text-center">{{ companyName }}</h3>
          </div>
        </div>

        <div class="mt-4">
          <div class="invoice-info d-flex justify-between">
            <div>
              <h4 class="mb-0 font-italic">No TTPB: {{ item.ks }}</h4>
              <h3 class="mb-0 font-italic">
                Nama Kapal: {{ item.vessel.vessel }}
              </h3>
              <h3 class="mb-0 font-italic">
                Nomor Muat / Cont: {{ item.container.no_container }} /
                {{ item.container.no_seal }} - KC: {{ item.container.kc }}
              </h3>
            </div>
            <div class="ml-3">
              Kepada Yth, {{ item.ttb.penerima_detil.nama_lengkap }} <br />
              {{ item.ttb.alamat_penerima }} <br />
              {{ item.ttb.penerima_detil.telp }}
            </div>
          </div>

          <div class="items mt-3">
            <table width="100%">
              <thead>
                <th>KS</th>
                <th>TTB</th>
                <th>Dikirim Oleh</th>
                <th>Ditujukan Kepada</th>
                <th>Koli Diantar</th>
                <!-- <th>Total Kubikasi</th> -->
                <!-- <th>Total Tonase</th> -->
                <th>Keterangan Barang</th>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{ item.ks }}</td>
                  <td class="text-center">
                    {{ item.ttb.kodettb }} / {{ item.ttb.nottb }}
                  </td>
                  <td class="text-center">
                    {{ item.ttb.pengirim_detil.nama_lengkap }}
                  </td>
                  <td class="text-center">
                    {{ item.ttb.penerima_detil.nama_lengkap }}
                  </td>
                  <td class="text-center">{{ item.koli_in }}</td>
                  <!-- <td class="text-center">
                    {{ total_kubikasi(item.ttb.ttb_rinci) }}
                  </td> -->
                  <!-- <td class="text-center">
                    {{ total_tonase(item.ttb.ttb_rinci) }}
                  </td> -->
                  <td class="text-center">
                    <ul>
                      <li v-for="ttb in item.ttb.ttb_detil" :key="ttb.id">
                        {{ ttb.nama_barang }}
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ul class="mt-2">
            <li>
              Isi collie diluar tanggung jawab Pihak Ekspedisi apabila packing
              utuh.
            </li>
            <li>
              Apabila terdapat kekurangan harap beri catatan di Tanda Terima ini
              dan di Fax - kan ke no (0561)-747378
            </li>
            <li>
              Pengaduan hanya dapat dilayani dalam jangka waktu max. 1x24 jam
              setelah barang diterima, ke no.(0561)-747377 / 7069321 / 7012121
            </li>
            <li>
              Jika tidak ada remarks dari pihak penerima berarti barang-barang
              tersebut diatas telah diterima dalam keadaan baik dan benar.
            </li>
          </ul>

          <table width="100%" class="mt-3">
            <tr>
              <td width="60%">
                Catatan:
              </td>
              <td width="40%">
                Pontianak,
                ......................................................................
              </td>
            </tr>
            <tr>
              <td colspan="2"><span style="opacity: 0">.</span></td>
            </tr>
            <tr>
              <td colspan="2"><span style="opacity: 0">.</span></td>
            </tr>
            <tr>
              <td></td>
              <td>
                <tr>
                  <td>
                    Yang Menyerahkan <br />
                    Nama Jelas
                  </td>
                  <td style="padding-left: 4rem">
                    Penerima <br />
                    Cap + Tanda Tangan
                  </td>
                </tr>
              </td>
            </tr>
          </table>

          <!-- <v-row>
            <v-col cols="12" md="6">
              Catatan:
            </v-col>
            <v-col cols="12" md="6">
              Pontianak,
              ......................................................................
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6"> </v-col>
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12" md="6">
                  Yang menyerahkan <br />
                  Nama Jelas
                </v-col>
                <v-col cols="12" md="6">
                  Penerima <br />
                  Cap + Tanda Tangan
                </v-col>
              </v-row>
            </v-col>
          </v-row> -->
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import variableMixin from "@/mixins/variableMixin";

export default {
  mixins: [variableMixin],
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        kc: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  watch: {
    "formData.kc"(val) {
      if (val) {
        this.formData.kc = val.toUpperCase();
      }
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchKC() {
      this.state.loading = true;

      await axios
        .get(`laporan/ttpb?kc=${this.formData.kc}`)
        .then(res => {
          if (res.data.length) {
            if (!res.data[0].vessel) {
              this.state.noData = true;
            } else {
              this.state.noData = false;
              this.data = res.data;
            }
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    total_koli(data) {
      let total = 0;

      data.forEach(invoice => {
        total += parseInt(invoice.koli);
      });

      return total;
    },
    total_kubikasi(data) {
      let total = 0;

      data.forEach(invoice => {
        total += invoice.m3;
      });

      return total.toFixed(2);
    },
    total_tonase(data) {
      let total = 0;

      data.forEach(invoice => {
        total += invoice.ton;
      });

      return total.toFixed(2);
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  }
};
</script>

<style type="text/css" media="print">
div.page-break {
  page-break-after: always !important;
  page-break-inside: avoid !important;
}
</style>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}

.right .border {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
}

.right .border-dotted {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
  border-style: dashed;
}
</style>
